export var CLONE_TOP = 'top';
export var CLONE_BOTTOM = 'bottom';
export var CLONE_LEFT = 'left';
export var CLONE_TOP_LEFT_CORNER = 'top_left_corner';
export var CLONE_BOTTOM_LEFT_CORNER = 'bottom_left_corner';
export var CLONE_TYPES = [CLONE_TOP, CLONE_BOTTOM, CLONE_LEFT, CLONE_TOP_LEFT_CORNER, CLONE_BOTTOM_LEFT_CORNER];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_handsontable@8.4.0@handsontable/3rdparty/walkontable/src/overlay/constants.mjs
// module id = null
// module chunks = 